<template>
  <div class="store-container">
    <!-- 顶部轮播图区域 -->
    <div class="banner-section">
      <a-carousel class="banner-carousel" autoplay ref="carousel">
        <div class="carousel-item">
          <img src="@/assets/lunbo1.jpg" alt="轮播图1" />
          <div class="carousel-content">
            <h2>素描绘画</h2>
            <p>根据客户需求制作手工素描绘画，制作过程提供视频、照片</p>
          </div>
        </div>
        <div class="carousel-item">
          <img src="@/assets/6.jpg" alt="轮播图2" />
          <div class="carousel-content">
            <h2>ig素材扩展</h2>
            <p>提供我们ig图片，我们能给你定制专属的人物模型，你可以让她在想要的场景下生成你想要的图片</p>
          </div>
        </div>
        <div class="carousel-item">
          <img src="@/assets/9.jpg" alt="轮播图3" />
          <div class="carousel-content">
            <h2>新人设定制</h2>
            <p>定制一个全新的人设，让你的素材更为的丰富</p>
          </div>
        </div>
      </a-carousel>
      <div class="carousel-controls">
        <button class="prev-btn" @click="prev"><left-outlined /></button>
        <button class="next-btn" @click="next"><right-outlined /></button>
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="content-section">
      <h2 class="section-title">选购区域</h2>
      
      <div class="category-grid">
        <!-- 亚洲男 -->
        <div class="category-card" @click="goToCategory('asian-male')">
          <div class="image-wrapper">
            <img src="@/assets/14.jpg" alt="风景图片" />
          </div>
          <div class="category-info">
            <h3>亚洲男</h3>
            <div class="hover-icon">
              <plus-outlined />
            </div>
          </div>
        </div>

        <!-- 亚洲女 -->
        <div class="category-card" @click="goToCategory('asian-female')">
          <div class="image-wrapper">
            <img src="@/assets/3.jpg" alt="人物图片" />
          </div>
          <div class="category-info">
            <h3>亚洲女</h3>
            <div class="hover-icon">
              <plus-outlined />
            </div>
          </div>
        </div>

        <!-- 欧洲男 -->
        <div class="category-card" @click="goToCategory('european-male')">
          <div class="image-wrapper">
            <img src="@/assets/15.jpg" alt="试物图片" />
          </div>
          <div class="category-info">
            <h3>欧美男</h3>
            <div class="hover-icon">
              <plus-outlined />
            </div>
          </div>
        </div>

        <!-- 欧洲女 -->
        <div class="category-card" @click="goToCategory('european-female')">
          <div class="image-wrapper">
            <img src="@/assets/5.jpg" alt="抽象图片" />
          </div>
          <div class="category-info">
            <h3>欧美女</h3>
            <div class="hover-icon">
              <plus-outlined />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { LeftOutlined, RightOutlined, PlusOutlined } from '@ant-design/icons-vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'StorePage',
  components: {
    LeftOutlined,
    RightOutlined,
    PlusOutlined
  },
  setup() {
    const router = useRouter()

    const goToCategory = (category) => {
      router.push(`/store/${category}`)
    }

    return {
      goToCategory
    }
  },
  methods: {
    prev() {
      this.$refs.carousel.prev()
    },
    next() {
      this.$refs.carousel.next()
    }
  }
})
</script>

<style scoped>
.store-container {
  width: 100%;
  min-height: 100vh;
  background: #000;
  color: #fff;
}

.banner-section {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #000;
}

.banner-carousel {
  height: 100%;
}

.banner-carousel :deep(.slick-slide) {
  height: 100vh;
  overflow: hidden;
}

.banner-carousel :deep(.slick-track) {
  height: 100vh;
}

.carousel-item {
  height: 100vh;
  position: relative;
  overflow: hidden;
  display: flex !important;
  align-items: center;
  justify-content: center;
  background: #000;
}

.carousel-item img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: brightness(0.8);
}

.carousel-content {
  position: absolute;
  bottom: 15%;
  left: 10%;
  transform: none;
  text-align: left;
  color: #fff;
  z-index: 2;
  width: 80%;
  padding: 0;
  pointer-events: none;
}

.carousel-content h2 {
  font-size: 4rem;
  margin-bottom: 1rem;
  font-weight: 300;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  letter-spacing: 2px;
}

.carousel-content p {
  font-size: 1.8rem;
  opacity: 0.9;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
  letter-spacing: 1px;
}

.carousel-controls {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  padding: 0 30px;
  z-index: 3;
}

.carousel-controls button {
  background: rgba(255, 255, 255, 0.15);
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);
}

.carousel-controls button:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: scale(1.1);
}

.content-section {
  padding: 60px 40px;
  max-width: 1400px;
  margin: 0 auto;
}

.section-title {
  font-size: 1.8rem;
  margin-bottom: 40px;
  font-weight: 300;
  color: #fff;
}

.category-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.category-card {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  aspect-ratio: 1;
}

.image-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.category-card:hover .image-wrapper img {
  transform: scale(1.05);
}

.category-info {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.category-info h3 {
  color: #fff;
  margin: 0;
  font-size: 1.2rem;
  font-weight: 400;
}

.hover-icon {
  opacity: 0;
  transform: translateY(10px);
  transition: all 0.3s ease;
}

.category-card:hover .hover-icon {
  opacity: 1;
  transform: translateY(0);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .content-section {
    padding: 40px 20px;
  }

  .category-grid {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
  }

  .carousel-content h2 {
    font-size: 2.5rem;
  }

  .carousel-content p {
    font-size: 1.2rem;
  }

  .carousel-content {
    bottom: 20%;
    left: 5%;
    width: 90%;
  }
}
</style> 